import React, { useEffect, useState } from "react";

export default function YearRangeField({ card, setCard }) {
  const [showEndYear, setShowEndYear] = useState(Boolean(card?.year_end));

  useEffect(() => {
    if (card?.year_end) setShowEndYear(true);
  }, [card?.year_end]);

  const update = (name, value) => {
    setCard((prev) => ({ ...prev, [name]: value }));
  };

  const removeEndYear = () => {
    setShowEndYear(false);
    setCard((prev) => ({ ...prev, year_end: "" }));
  };

  return (
    <div className={`year-range-field ${showEndYear ? "is-range" : ""}`}>
      <input
        name="year"
        type="number"
        inputMode="numeric"
        min="1"
        max="9999"
        step="1"
        placeholder={showEndYear ? "Start Year" : "Year"}
        value={card?.year ?? ""}
        onChange={(e) => update("year", e.target.value)}
        className="form-input year-range-input"
      />

      {!showEndYear ? (
        <button
          type="button"
          className="year-range-add"
          onClick={() => setShowEndYear(true)}
          title="Add year range"
          aria-label="Add year range"
        >
          +
        </button>
      ) : (
        <>
          <span className="year-range-separator" aria-hidden="true">–</span>
          <input
            name="year_end"
            type="number"
            inputMode="numeric"
            min={card?.year || "1"}
            max="9999"
            step="1"
            placeholder="End Year"
            value={card?.year_end ?? ""}
            onChange={(e) => update("year_end", e.target.value)}
            className="form-input year-range-input"
          />
          <button
            type="button"
            className="year-range-remove"
            onClick={removeEndYear}
            title="Remove year range"
            aria-label="Remove year range"
          >
            ×
          </button>
        </>
      )}
    </div>
  );
}
